import Splide from '@splidejs/splide';

export function initMobileSlider() {
  if (window.innerWidth < 720) {
    const wrapper = document.querySelector(
      '.po-intro__container-escape.po-intro__mobile-slider'
    );
    if (!wrapper || wrapper.querySelector('.po-intro__mobile-slider-wrapper'))
      return;

    const currentFilter =
      new URLSearchParams(window.location.search).get('filter') ||
      'recommended';
    const lang = window.PO_LANG || 'en';

    fetch(
      // `/wp-admin/admin-ajax.php?action=po_load_mobile_slider&filter=${currentFilter}&lang=${lang}`
      '/blog/wp-admin/admin-ajax.php?action=po_load_mobile_slider&filter=${currentFilter}&lang=${lang}'
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          wrapper.insertAdjacentHTML('beforeend', data.data);
          //   initFilterTitleDropdown();
          const splideEl = wrapper.querySelector(
            '.po-post-main-index-slider__slider .splide'
          );
          if (splideEl) {
            new Splide(splideEl, {
              type: 'loop',
              perPage: 1.5,
              perMove: 1,
              interval: 3000,
              speed: 600,
              gap: '20px',
              padding: { left: 20 },
              pagination: false,
              arrows: false,
            }).mount();
          }
        }
      });
  }
}
